module.exports = __webpack_public_path__ + "img/baizhi-back-four@2x.50fe1f70.jpg";